import Axios from "axios";

const url = '/alert';

const notificationsApi = {
    all: {
        get: () => {
          return Axios.get(`${url}`);
        }
      }
};

export default notificationsApi;